import httpRequest from '../../common/lib/http-request';

// *******************
// STORE SERVICES
// *******************

function getActiveProducts(form, membersArea, activeRegistration) {
    return httpRequest({
        url: '/Order/product?form=' + form + '&membersArea=' + membersArea + '&activeRegistration=' + activeRegistration,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function getOrdersByAssociate(associateId) {
    return httpRequest({
        url: '/Order/associate/' + associateId,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function submitOrder(request) {
    return httpRequest({
        url: '/Order/submit',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

function generateCreditCardCheckout(request) {
    return httpRequest({
        url: '/Order/cc/checkout',
        method: 'POST',
        data: request
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const StoreService = { getActiveProducts, getOrdersByAssociate, submitOrder, generateCreditCardCheckout }

export default StoreService;